import React, { useMemo } from 'react';
import { Box, ShimmerBox, Text } from '@common-fe/common-fe';
import _ from 'lodash';
export interface DescriptionBaseItem {
  label: string;
  value: string;
}
export interface DescriptionBaseProps {
  title?: string | null;
  isLoading?: boolean;
  testId?: string;
  items: DescriptionBaseItem[];
}

const ReportCardDescriptionBase: React.FC<DescriptionBaseProps> = ({
  title,
  items = [],
  isLoading,
  testId,
}) => {
  const nodes = useMemo(() => {
    return items.map((item, index) => (
      <>
        <Box direction="row" align="center">
          <Text
            color="textSecondary"
            size="small"
            data-testid={`${testId}_description_label_${index + 1}`}
            weight={500}
          >
            {item.label}:
          </Text>
          <Box>
            {isLoading ? (
              <ShimmerBox
                data-testid={`${testId}_description_loading_${index + 1}`}
                margin={{ left: 'spacing2' }}
                round="snackbarRound"
                height="16px"
                width="40px"
              />
            ) : (
              <Text
                data-testid={`${testId}_description_text_${index + 1}`}
                size="small"
                weight={500}
                margin={{ left: 'spacing4' }}
              >
                {item.value}
              </Text>
            )}
          </Box>
        </Box>
        {_.last(items) !== item && (
          <Box width="1px" background="border1" height="18px" margin={{ horizontal: 'spacing8' }} />
        )}
      </>
    ));
  }, [isLoading, items, testId]);

  return (
    <Box
      background="module"
      pad={{ vertical: 'spacing8', horizontal: 'spacing16' }}
      round="container1Round"
      margin={{ top: 'spacing12' }}
      direction="column"
      border={{ size: 'small', color: 'border2' }}
    >
      <Text data-testid={`${testId}_description_title`} size="small" weight={500}>
        {title}
      </Text>
      <Box direction="row">{nodes}</Box>
    </Box>
  );
};
export default ReportCardDescriptionBase;
